import { memo, type MouseEvent } from "react";
import type { InventoryItem, SlotLocation, ContainerCapacity } from "../types";
import { SectionLabel } from "./SectionLabel";
import { InventoryGrid } from "./InventoryGrid";
import backpackIcon from "../assets/images/backpack-icon.webp";

interface Props {
  items: (InventoryItem | null)[];
  capacity: ContainerCapacity;
  selectedLocation?: SlotLocation | null;
  onItemClick: (item: InventoryItem, location?: SlotLocation) => void;
  onItemRightClick: (
    e: MouseEvent,
    item: InventoryItem,
    location?: SlotLocation,
  ) => void;
}

export const BackpackSection = memo(function BackpackSection({
  items,
  capacity,
  selectedLocation,
  onItemClick,
  onItemRightClick,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <SectionLabel
        icon={backpackIcon}
        title="Backpack"
        //    subtitle="here you keeping your stuff"
      />
      <InventoryGrid
        items={items}
        section="backpack"
        capacity={capacity}
        selectedLocation={selectedLocation}
        onItemClick={onItemClick}
        onItemRightClick={onItemRightClick}
      />
    </div>
  );
});
